import type { Commitment } from "@solana/web3.js";

export const confirmOptions: {
  skipPreflight: boolean;
  commitment: Commitment;
  preflightCommitment: Commitment;
} = {
  skipPreflight: true,
  commitment: "confirmed",
  preflightCommitment: "confirmed",
};
